import moment from 'moment';

/**
 * Format a date string or timestamp to a display format.
 * @param {string|number|Date} dateValue - Date value to format
 * @param {string} [format='DD.MM.YYYY'] - Moment.js format string
 * @returns {string} Formatted date string, or empty string if no value
 */
export const formatDate = (dateValue, format = 'DD.MM.YYYY') => {
  if (!dateValue) return '';
  return moment(dateValue).format(format);
};
